import { isAdjustmentEventType, isParentPDF } from 'components/pages/finance/NewInvoice/services/service';

import { Amount } from '../../../../../shared/amount-view/Amount/Amount';
import { stylesContent } from '../../EncounterInvoiceTemplateStyles';

export const ReimbursementItem = ({ item, invoiceType }) => {
  const showContent = !isAdjustmentEventType(item.invoiceType) || !isParentPDF(invoiceType);

  return (
    <div
      style={{ ...stylesContent.invoiceItem, display: 'flex', gap: '3px', paddingLeft: '40px' }}
      className="row-item"
      data-testid="reimbursement-item"
    >
      {showContent && (
        <>
          {`${item?.type || '—'}`}
          <Amount coinsAmount={item.amount} showDollarSign={true} />
        </>
      )}
    </div>
  );
};
